export class MenuModel{
    id : number;
    idMenuPadre : number;
    nombre : string;
    descripcion : string;
    descripcionCompleta : string;
    url : string;
    icono : string;

    constructor () {
        this.id = 0
        this.idMenuPadre=0
        this.nombre = ""
        this.descripcion = ""
        this.descripcionCompleta = ""
        this.url = ""
        this.icono = ""
      }
}

export class  Card {
  title: string;
  subtitle: string;
  routerLink: string;
  cssClass?: string;

  constructor(title: string, subtitle: string, routerLink: string) {
    this.title = title;
    this.subtitle = subtitle;
    this.routerLink = routerLink;
  }
}
export class Section{
       
  id: string;
  title: string;
  cards: Card[];
  constructor(id: string, title: string, cards: Card[]) {
    this.id = id;
    this.title = title;
    this.cards = cards;
  }
}